import React, { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import NotificationSnackbar from '../../../components/notificationSnackbar';
import LiveSendingToggleCard from './liveSendingToggleCard';
import {
    getEmailConfiguration,
    updateEmailConfiguration,
    getSmsConfiguration,
    updateSmsConfiguration,
} from './communications.service';

function Communications() {
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const notify = (message, severity) => setSnackbar({ open: true, message, severity });
    const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, open: false }));

    return (
        <Box>
            <Typography className="app-page-title" sx={{ fontSize: 30, fontWeight: 700, color: '#202124', mb: 3 }}>
                Communications
            </Typography>

            <Stack spacing={3}>
                <LiveSendingToggleCard
                    title="Live email sending"
                    description={
                        <>
                            Master switch for outbound emails across the whole platform &mdash; including eK Link
                            sign-up and Ecosystem Integrator onboarding notifications. When turned off, emails are
                            prepared and logged for audit but never delivered to recipients.
                        </>
                    }
                    ariaLabel="Toggle live email sending"
                    confirmTitleId="email-config-confirm-title"
                    confirmTitleOn="Turn on live email sending?"
                    confirmTitleOff="Turn off live email sending?"
                    confirmTextOn="Emails will start being delivered to recipients across the entire platform, including eK Link sign-up and Ecosystem Integrator onboarding."
                    confirmTextOff="Outbound emails will stop being delivered platform-wide. Messages will still be prepared and logged, but recipients will not receive them."
                    successNoun="Live email sending"
                    loadErrorText="Failed to load email configuration"
                    saveErrorText="Failed to update email configuration"
                    getConfig={getEmailConfiguration}
                    updateConfig={updateEmailConfiguration}
                    onNotify={notify}
                />

                <LiveSendingToggleCard
                    title="Live SMS sending (Twilio)"
                    description={
                        <>
                            Master switch for outbound SMS across the whole platform &mdash; OTP codes (via Twilio
                            Verify) for eK Link sign-up and login, plus other SMS notifications. When turned off, no
                            message is sent and a fixed test OTP (1234) is accepted so flows stay testable. This
                            switch overrides the SMS_ENABLED and SMS_USE_HARDCODED_OTP environment variables.
                        </>
                    }
                    ariaLabel="Toggle live SMS sending"
                    confirmTitleId="sms-config-confirm-title"
                    confirmTitleOn="Turn on live SMS sending?"
                    confirmTitleOff="Turn off live SMS sending?"
                    confirmTextOn="Real SMS messages will start being delivered through Twilio across the entire platform, and OTP codes will be randomly generated. Ensure your Twilio credentials are configured."
                    confirmTextOff="Outbound SMS will stop being delivered platform-wide. Messages will still be prepared and logged, and OTP flows will fall back to the fixed test code (1234)."
                    successNoun="Live SMS sending"
                    loadErrorText="Failed to load SMS configuration"
                    saveErrorText="Failed to update SMS configuration"
                    getConfig={getSmsConfiguration}
                    updateConfig={updateSmsConfiguration}
                    onNotify={notify}
                />
            </Stack>

            <NotificationSnackbar
                open={snackbar.open}
                onClose={closeSnackbar}
                message={snackbar.message}
                severity={snackbar.severity}
            />
        </Box>
    );
}

export default Communications;
